import { memo } from 'react'
import clsx from 'clsx'
import { Button, Card, Form, Paragraph, Select, Title } from 'components/common'
import { ProductStatus } from 'lib/graphql/storeadmin'

export interface ProductStatusProps {
  status?: ProductStatus
  loading?: boolean
  onUnarchive?: () => void
}

export interface ProductStatusFromValues {
  status: ProductStatus
}

export const ProductStatusSelect = memo(
  ({
    status = ProductStatus.Active,
    loading = false,
    onUnarchive,
  }: ProductStatusProps): JSX.Element => (
    <Card shadow loading={loading}>
      <Title level={5}>ステータス</Title>

      {status !== 'ARCHIVED' && (
        <>
          <Form.Item noStyle shouldUpdate>
            {() => (
              <Form.Item name="status" initialValue={status} noStyle>
                <Select style={{ width: '100%' }}>
                  <Select.Option value={ProductStatus.Active}>
                    アクティブ
                  </Select.Option>
                  <Select.Option value={ProductStatus.Inactive}>
                    非アクティブ
                  </Select.Option>
                </Select>
              </Form.Item>
            )}
          </Form.Item>
          <div className="opacity-60 mt-4">
            施設の稼働状態を設定できます。
            <br />
            非アクティブに設定すると、施設管理画面以外に表示されなくなります。
          </div>
        </>
      )}

      {status === 'ARCHIVED' && (
        <div className={clsx('rounded-lg', 'bg-gray-100', 'p-8')}>
          <div
            className={clsx('flex', 'flex-col', 'flex-center', 'items-center')}
          >
            <Paragraph className={clsx('text-2xl')} strong>
              アーカイブ済み
            </Paragraph>
            <Paragraph>
              施設管理画面にのみ表示されます。それ以外では非表示です。
            </Paragraph>
            <Button onClick={onUnarchive}>アーカイブを解除する</Button>
          </div>
        </div>
      )}
    </Card>
  )
)
